<template>
  <div class="pt10">
    <div class="tool_company video-body" :class="property.video==''?'none_video':''">
      <video :src="property.video" id="videoPlay" class="video" v-if="property.video" :poster="property.poster">您的浏览器不支持 video 视屏播放。</video>
    </div>
  </div>
</template>
<script>
  export default {
    props: ["property"],
    data() {
      return {
        form: {}
      };
    }
  };
</script>


